export default __webpack_public_path__ + "static/media/Nunito-Regular.65bb0a15.ttf";